import { render, staticRenderFns } from "./languageswitcherlist.vue?vue&type=template&id=2ff9f60b&scoped=true"
import script from "./languageswitcherlist.vue?vue&type=script&lang=js"
export * from "./languageswitcherlist.vue?vue&type=script&lang=js"
import style0 from "./languageswitcherlist.vue?vue&type=style&index=0&id=2ff9f60b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9f60b",
  null
  
)

export default component.exports